import { Fragment, useState, useEffect } from 'react'
import {
  EuiBasicTable,
  EuiText,
  EuiSpacer,
  EuiHorizontalRule,
  Comparators,
  EuiAccordion,
  EuiDescriptionList,
  EuiScreenReaderOnly,
  EuiButtonIcon,
  RIGHT_ALIGNMENT,
} from '@elastic/eui'

import logService from '../services/log.service'

export default function AdminKpisLogs() {
  const [logs, setLogs] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(10)

  const [sortField, setSortField] = useState('document.id')
  const [sortDirection, setSortDirection] = useState('desc')

  const [pageOfItems, setPageOfItems] = useState([])
  const [totalItemCount, setTotalItemCount] = useState(0)

  const [itemIdToExpandedRowMap, setItemIdToExpandedRowMap] = useState({})

  const onTableChange = ({ page = {}, sort = {} }) => {
    const { index: pageIndex, size: pageSize } = page

    const { field: sortField, direction: sortDirection } = sort

    setPageIndex(pageIndex)
    setPageSize(pageSize)
    setSortField(sortField)
    setSortDirection(sortDirection)
  }

  useEffect(() => {
    if (!isLoading) {
      setTotalItemCount(logs.length)
      const startIndex = pageIndex * pageSize
      setPageOfItems(
        logs
          .slice()
          .sort(
            Comparators.property(sortField, Comparators.default(sortDirection)),
          )
          .slice(startIndex, Math.min(startIndex + pageSize, logs.length)),
      )
    }
  }, [logs, isLoading, pageIndex, pageSize, sortField, sortDirection])

  useEffect(() => {
    logService
      .getLogs('kpi')
      .then(async (response) => {
        console.log('Axios response => ', response)
        const rows = response.data.items
        if (!rows || !rows[0]) {
          setLogs([])
          setIsLoading(false)
        } else {
          setLogs(rows)
          setIsLoading(false)
        }
      })
      .catch((error) => {
        console.log('Axios error => ', error)
      })
  }, [])

  const columns = [
    {
      field: 'document.datetime_log',
      name: 'Date',
      dataType: 'string',
      sortable: true,
    },
    {
      field: 'document.id',
      name: 'Id',
      dataType: 'number',
      sortable: true,
    },
    {
      field: 'document.code',
      name: 'Code',
      dataType: 'number',
      sortable: true,
    },
    {
      name: (
        <EuiScreenReaderOnly>
          <span>Expand rows</span>
        </EuiScreenReaderOnly>
      ),
      align: RIGHT_ALIGNMENT,
      width: '40px',
      isExpander: true,
      render: (item) => (
        <EuiButtonIcon
          onClick={() => toggleDetails(item)}
          aria-label={itemIdToExpandedRowMap[item.id] ? 'Collapse' : 'Expand'}
          iconType={itemIdToExpandedRowMap[item.id] ? 'arrowUp' : 'arrowDown'}
        />
      ),
    },
  ]

  const sorting = {
    sort: {
      field: sortField,
      direction: sortDirection,
    },
  }

  const pagination = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    totalItemCount: totalItemCount,
    pageSizeOptions: [10, 20, 0],
    showPerPageOptions: true,
  }

  const formatData = (data) => {
    try {
      const fields = data.result.fields
      const rows = data.result.rows
      let association = []
      console.log(association)
      for (const k in fields) {
        console.log('k => ', k)
        association = [
          ...association,
          { title: fields[k], description: JSON.stringify(rows[k]) },
        ]
      }
      return (
        <EuiDescriptionList
          compressed={true}
          type="responsiveColumn"
          textStyle="reverse"
          listItems={association}
        />
      )
    } catch {}
  }

  const toggleDetails = (item) => {
    const itemIdToExpandedRowMapValues = { ...itemIdToExpandedRowMap }
    if (itemIdToExpandedRowMapValues[item.id]) {
      delete itemIdToExpandedRowMapValues[item.id]
    } else {
      const {
        er_supervise,
        log,
        mitre_attack,
        perimetre_supervise,
      } = item.document.document
      itemIdToExpandedRowMapValues[item.id] = (
        <div>
          <EuiAccordion id="er_supervise" buttonContent="ER Supervise">
            {formatData(er_supervise)}
          </EuiAccordion>
          <EuiSpacer size="xs"></EuiSpacer>
          <EuiAccordion id="mitre_attack" buttonContent="Mitre Att&amp;ck">
            {formatData(mitre_attack)}
          </EuiAccordion>
          <EuiSpacer size="xs"></EuiSpacer>
          <EuiAccordion
            id="perimetre_supervise"
            buttonContent="Perimetre Supervise"
          >
            {formatData(perimetre_supervise)}
          </EuiAccordion>
          <EuiSpacer size="xs"></EuiSpacer>
          <EuiAccordion id="log" buttonContent="Log">
            {formatData(log)}
          </EuiAccordion>
        </div>
      )
    }
    setItemIdToExpandedRowMap(itemIdToExpandedRowMapValues)
  }

  const resultsCount =
    pageSize === 0 ? (
      <strong>All</strong>
    ) : (
      <>
        <strong>
          {pageSize * pageIndex + 1}-{pageSize * pageIndex + pageSize}
        </strong>{' '}
        of {totalItemCount}
      </>
    )

  return (
    <Fragment>
      <EuiText size="xs">
        Showing {resultsCount} <strong>Kpis</strong>
      </EuiText>
      <EuiSpacer size="s" />
      <EuiHorizontalRule margin="none" style={{ height: 2 }} />
      <EuiBasicTable
        loading={isLoading}
        items={pageOfItems}
        itemId="id"
        itemIdToExpandedRowMap={itemIdToExpandedRowMap}
        isExpandable={true}
        columns={columns}
        pagination={pagination}
        sorting={sorting}
        tableLayout="auto"
        onChange={onTableChange}
      />
    </Fragment>
  )
}
